import { User } from '@/core/entity';

export enum AppStatus {
  INIT = 'init',
  READY = 'ready',
  ERROR = 'error',
}

export type AppStartPresenterFunc = (
  err: Error | null,
  status: AppStatus,
  user: User | null,
) => void;
